import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="play"
export default class extends Controller {
  connect() {
    // Add keyboard navigation support if needed in the future
    console.log("Play controller connected")
  }

  disconnect() {
    console.log("Play controller disconnected")
  }
}
